import DoubleChevronRightSVG from '../../assets/svg/double-chevron-right.svg';

export default DoubleChevronRightSVG;
